import React from 'react';

import {
  Switch,
  FormGroup,
  FormControlLabel,
  Box,
  Tooltip,
} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

export default function CustomSwitch({
  checked,
  onChange,
  label,
  tooltipContent,
}) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <FormGroup>
        <FormControlLabel
          control={
            <Switch
              checked={checked}
              onChange={onChange}
              inputProps={{ 'aria-label': 'controlled' }}
            />
          }
          label={label}
        />
      </FormGroup>
      <Tooltip title={tooltipContent}>
        <InfoIcon style={{ fontSize: 16 }} />
      </Tooltip>
    </Box>
  );
}
